import { Add, AddCircle, ArrowDownward, ArrowDropDown, ArrowRight, Watch, WatchLater } from '@mui/icons-material'
import { Avatar, Badge, Button, Collapse, Divider, Fade, Grow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useContext } from 'react'
import { AsuntosContext } from '../../pages/asuntos/AsuntosPage'
import { deepOrange, deepPurple } from '@mui/material/colors';
import { TareaComponent } from './TareaComponent'
import { AuthContext } from '../../context/AuthContext'
export const AsuntoComponent = ({asunto}) => {
    const {asuntoSeleccionado, setAsuntoSeleccionado, setModalAgregaAsunto, setAgregandoTarea, agregandoTarea, tareaSeleccionada, setTareaSeleccionada} = useContext(AsuntosContext);
    const {usuario} = useContext(AuthContext);
    const [mostrarTareas, setMostrarTareas] = useState(false);

   // console.log('dbujando asunto', asunto, tareaSeleccionada);

    // useEffect(() => {
    //     console.log('selecciono tarea', tareaSeleccionada);
    // }, [tareaSeleccionada])
    

  return (
    // <Grow timeout={5} in={true} >
    <div
        onClick={() => {
            console.log('asunto en el que di click', asunto)
            if(asunto.IdAsuntoPadre>0) {
                setTareaSeleccionada(asunto);
            } else {
                setTareaSeleccionada();
                setAsuntoSeleccionado(asunto);
            }
        }}
        style={{
            display:'flex',
            flexDirection:'row',
            //flex:1,
            backgroundColor:'white',
            margin:6,
            borderRadius:10,
            padding:5,
            boxShadow: (asuntoSeleccionado?.IdAsunto || tareaSeleccionada?.IdAsunto)==asunto?.IdAsunto ? '1px 2px 9px #0f0f0f':'',
      //      transition: '2s, transform 2s',
            elevation:12

        }}
    >
        <div
            style={{
                display:'flex',
                flexDirection:'column',
                flex:1
            }}
        >
            <div
                style={{
                    display:'flex',
                    flexDirection:'row',
                    flex:1,
                    justifyContent:'space-between',
                    backgroundColor:'transparent'
                }}
            >
                <div
                    style={{display:'flex',
                        flexDirection:'column',
                        flex:1
                    }}
                >
                    <div
                        style={{
                            display:'flex',
                            flexDirection:'row',
                            justifyContent:'space-between'
                        }}
                    >
                        <Typography
                            style={{
                                fontWeight:600
                            }}
                            >
                            {asunto.Descripcion}
                        </Typography>
                        {
                            asunto?.IdAsuntoPadre<1 && (
                                <div
                                    key={asunto?.IdAsunto}
                                    onClick={() => {setAgregandoTarea(true); setModalAgregaAsunto(true)}}
                                    style={{
                                        display:'flex',
                                        flexDirection:'row',
                                        alignItems:'center'
                                    }}
                                >
                                    <Add style={{fontSize:14, color:'gray'}} />
                                    <Typography
                                        style={{
                                            fontWeight:300,
                                            fontSize:13,
                                            marginRight:20
                                        }}
                                        >
                                        Agregar tarea
                                    </Typography>
                                </div>
                            )
                        }
                    </div>
                    <div
                        style={{display:'flex',
                        flexDirection:'row',
                        flex:1,
                        justifyContent:'space-between'
                    }}
                    >
                        <Typography
                            style={{
                                fontWeight:'normal',
                                fontSize:12
                            }}
                            >
                            {asunto.Ruta}
                        </Typography>
                        <Typography
                            style={{
                                fontSize:12,
                                marginRight:10
                            }}
                        >
                            {asunto.PorcentajeAsunto}% Avance
                        </Typography>

                    </div>
                    <div
                        style={{display:'flex',
                        flexDirection:'row',
                        flex:1,
                        justifyContent:'space-between'
                    }}
                    >
                        <Typography
                            style={{fontSize:12}}
                        >Asunto #{asunto.IdAsunto}  Responsable {asunto.NombreResponsable}</Typography>
                    </div>
                    <Divider style={{
                            borderColor:'purple',
                            display:'flex',
                            flexDirection:'row',
                            flex:1
                        }} 
                    />
                </div>  
                <div
                    style={{
                        display:'flex',
                        flexDirection:'column',
                        justifyContent:'center',
                        backgroundColor:'transparent',
                        height:'100%'
                    }}
                >
                    <Badge badgeContent={<WatchLater style={{color:'green', fontSize:15}} />} >
                    </Badge> 
                    <Tooltip title={usuario?.Nombre+' '+usuario?.ApellidoPaterno}>
                    <Avatar sx={{ bgcolor: '#5F249F', marginRight:2 }}>
                        {usuario?.Nombre.charAt(0)+usuario?.ApellidoPaterno.charAt(0)}
                    </Avatar>
                    </Tooltip>
                </div>                  
            </div>
            <div
                style={{
                    display:'flex',
                    flexDirection:'row',
                    justifyContent:'space-between'
                }}
            >
                <Typography
                    style={{
                        fontWeight:'normal',
                        fontSize:14,
                        marginTop:5
                    }}
                >
                    {asunto.DescripcionAsunto}
                </Typography>
                <Button
                    onClick={() => {setModalAgregaAsunto(true); setAsuntoSeleccionado(asunto); setAgregandoTarea(true)}}
                    size='small'
                    variant='outlined'
                    style={{
                        marginTop:3,
                        textTransform:'unset',
                        color:'#002D72'
                    }}
                >
                   <AddCircle style={{fontSize:16, marginRight:5}} />  Agregar tarea
                </Button>
            </div>
            {
                asunto?.Tareas?.length>0 && (
                    <div
                        style={{
                            display:'flex',
                            flexDirection:'column'
                        }}
                    >
                    <div
                        style={{
                            display:'flex',
                            flexDirection:'row',
                            alignItems:'center'
                        }}
                    >
                    {
                        !mostrarTareas ? (
                        <ArrowRight 
                            onClick={() => setMostrarTareas(!mostrarTareas)}
                            style={{color:'gray'}} 
                        />
                        )
                        :
                        (
                            <ArrowDropDown
                            onClick={() => setMostrarTareas(!mostrarTareas)}
                            style={{color:'gray'}} 
                        />

                        )
                    }
                        <Typography
                            style={{
                                fontSize:12,
                                color:'gray'
                            }}
                        >
                            Mostrar táreas ({asunto.Tareas.length})
                        </Typography>
                        </div>
                        <Collapse timeout={800} orientation='vertical' in={mostrarTareas} >
                        <div>
                        {
                            mostrarTareas && (
                                asunto?.Tareas?.map(tarea => (
                                    <div
                                        key={tarea?.IdAsunto}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            console.log(tareaSeleccionada?.IdAsunto, tarea.IdAsunto)
                                            if(tareaSeleccionada?.IdAsunto==tarea.IdAsunto) {
                                                console.log('deseleccionar tarea')
                                                setTareaSeleccionada()
                                            } else {
                                                console.log('seleccionar tarea');
                                                setAsuntoSeleccionado(asunto);
                                                setTareaSeleccionada(tarea);
                                            }

                                        }}
                                    >
                                        <TareaComponent tarea={tarea} />
                                        <Divider />
                                    </div>
                                ))
                            )
                        }
                        </div>
                        </Collapse>
                    </div>
                )
            }
        </div>
    </div>
    // </Grow>
  )
}
